import { getOrderInstanceUtil } from '../../../../../models/utils'
import { cloneWorkoutExerciseDataUtil } from '../../../../workout-exercise/model/utils'
import { WORKOUT_SECTION_CLASS_NAME, WORKOUT_SECTION_KEY } from '../../../model'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import createReduxAction from '../../../../redux/actions/create'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import createWorkoutSectionAction from '../create'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_ANALYTICS_EVENT from '../../constants/analytics-event'
import getCurrentWorkoutSectionSelect from '../../selectors/get-current'
import getCurrentWorkoutExercisesWorkoutSectionSelect from '../../selectors/get-current-workout-exercises'
import cloneIfCantEditWorkoutAction from '../../../../workout/redux/actions/clone-if-cant-edit'
import getCurrentOrStartedWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started'

export function copyWorkoutSectionAction () {
  return async (dispatch, getState) => {
    const currentWorkout = getCurrentOrStartedWorkoutSelect(getState())
    if (!currentWorkout) {
      return
    }
    const workout = await dispatch(cloneIfCantEditWorkoutAction({
      workout: currentWorkout
    }))
    const currentWorkoutSection = getCurrentWorkoutSectionSelect(getState())
    const currentWorkoutExercises = getCurrentWorkoutExercisesWorkoutSectionSelect(
      getState())
    const newOrder = getOrderInstanceUtil(currentWorkoutSection) + 1

    dispatch(createWorkoutSectionAction({
      type: WORKOUT_SECTIONS_ACTION.COPY,
      analyticEvent: WORKOUT_SECTIONS_ANALYTICS_EVENT.COPIED,
      className: WORKOUT_SECTION_CLASS_NAME,
      changed: {
        [WORKOUT_SECTION_KEY.NAME]: (
          getValueReduxUtil(currentWorkoutSection, WORKOUT_SECTION_KEY.NAME)
        ),
        [WORKOUT_SECTION_KEY.NOTES]: (
          getValueReduxUtil(currentWorkoutSection, WORKOUT_SECTION_KEY.NOTES)
        ),
        [WORKOUT_SECTION_KEY.TYPE]: (
          getValueReduxUtil(currentWorkoutSection, WORKOUT_SECTION_KEY.TYPE)
        ),
        [WORKOUT_SECTION_KEY.ORDER]: newOrder,
        [WORKOUT_SECTION_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
          getState()),
        [WORKOUT_SECTION_KEY.WORKOUT_EXERCISES]: currentWorkoutExercises.map(
          workoutExercise => dispatch(createReduxAction({
            type: 'WORKOUTS_SECTIONS_CLONE_WORKOUT_EXERCISES',
            payload: {
              data: {
                changed: cloneWorkoutExerciseDataUtil(workoutExercise)
              }
            }
          }))), // TODO add references
        [WORKOUT_SECTION_KEY.WORKOUT_ID]: getIdReduxUtil(workout)
      }
    }))
  }
}
